const e = {
  id: "TristateMegabucks",
  name: "Megabucks",
  style: {
    colorPrimary: "#194b7e",
    extraBall: {
      bg: "#194b7e",
      color: "#ffffff"
    }
  }
};
export {
  e as default
};
